import { render, staticRenderFns } from "./ListRegion.vue?vue&type=template&id=fba12a4a&scoped=true"
import script from "./ListRegion.vue?vue&type=script&lang=js"
export * from "./ListRegion.vue?vue&type=script&lang=js"
import style0 from "./ListRegion.vue?vue&type=style&index=0&id=fba12a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba12a4a",
  null
  
)

export default component.exports